import React, { Component, } from 'react';
import { arrayOf, object, string, } from 'prop-types';

import keys from 'lodash/keys';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import Table from '../../../../legacy-tv-ui/Table';
import Td from '../../../../legacy-tv-ui/Td';
import Tr from '../../../../legacy-tv-ui/Tr';
import Th from '../../../../legacy-tv-ui/Th';
import { toPercentage, } from '../../../../utils';
import Footnote from '../../../../components/Footnote';

export class RRTable extends Component {
  static propTypes = {
    data: arrayOf(object),
    footnote: string,
  }
  static defaultProps = {
    data: [],
    footnote: '',
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const fundsData = this.props.data;
    const firstKey = keys(fundsData[0]).filter(k => k !== 'name' && k !== 'fund_id')[2];
    const secondKey = keys(fundsData[0]).filter(k => k !== 'name' && k !== 'fund_id')[1];
    const thirdKey = keys(fundsData[0]).filter(k => k !== 'name' && k !== 'fund_id')[0];
    return (
      <Grid
        item
        xs={7}
        style={{
          padding: 20,
          paddingLeft: 0,
        }}
      >
        <Widget>
          <Table style={{ width: '100%', }}>
            <thead>
              <Tr>
                <Th />
                <Th>基金名稱</Th>
                <Th>
                  {firstKey.substr(0, 1).toUpperCase() + firstKey.substr(1).toLowerCase()}
                </Th>
                <Th>
                  {secondKey.substr(0, 1).toUpperCase() + secondKey.substr(1).toLowerCase()}
                </Th>
                <Th>
                  {thirdKey.substr(0, 1).toUpperCase() + thirdKey.substr(1).toLowerCase()}
                </Th>
              </Tr>
            </thead>
            <tbody>
              {
                this.props.data.map(fund => (
                  <Tr key={fund.fund_id}>
                    <Td>{fund.fund_id}</Td>
                    <Td style={{ width: '100%', }}>{fund.name}</Td>
                    <Td style={{ textAlign: 'right', }}>
                      {toPercentage(fund[firstKey], 0)}
                    </Td>
                    <Td style={{ textAlign: 'right', }}>
                      {toPercentage(fund[secondKey], 0)}
                    </Td>
                    <Td style={{ textAlign: 'right', }}>
                      {toPercentage(fund[thirdKey], 0)}
                    </Td>
                  </Tr>
                ))
              }
            </tbody>
          </Table>
          {
            this.props.footnote &&
            <Footnote>{this.props.footnote}</Footnote>
          }
        </Widget>
      </Grid>
    );
  }
}

export default RRTable;



// WEBPACK FOOTER //
// ./src/scenes/Performance/components/RRTable/index.js